import { Layout } from '@/components/layout/Layout';
import { motion } from 'framer-motion';
import { RotateCcw, Phone, MapPin, AlertTriangle } from 'lucide-react';

const RefundPolicyPage = () => {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-4xl mx-auto"
        >
          {/* Header */}
          <div className="text-center mb-12">
            <div className="flex justify-center mb-4">
              <div className="p-3 bg-primary/10 rounded-full">
                <RotateCcw className="h-8 w-8 text-primary" />
              </div>
            </div>
            <h1 className="text-3xl md:text-4xl font-bold mb-4">
              🔄 Refund & Return Policy – <span className="text-gradient-rainbow">AuraKart</span>
            </h1>
            <p className="text-muted-foreground text-lg">
              Effective Date: 9 January 2026
            </p>
          </div>

          {/* Content */}
          <div className="prose prose-lg max-w-none space-y-8">
            <div className="bg-card border rounded-lg p-6">
              <p className="text-muted-foreground">
                AuraKart aims to ensure customer satisfaction while maintaining fair and transparent policies for sellers.
              </p>
            </div>

            <section>
              <h2 className="text-2xl font-bold mb-4">1. Cancellation Policy</h2>
              <ul className="space-y-2 text-muted-foreground">
                <li>• Customers may cancel orders within <span className="font-semibold text-foreground">1 day</span> of placing the order, provided the order has not been shipped</li>
                <li>• Cancellation requests after shipping will not be accepted</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">2. Return & Refund Policy</h2>
              <ul className="space-y-2 text-muted-foreground">
                <li>• Products may be eligible for return based on seller-specific return policies</li>
                <li>• Refunds are processed within <span className="font-semibold text-foreground">8–10 business days</span> after successful return pickup and quality inspection</li>
                <li>• Refunds are issued to the original payment method used at checkout</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">3. Non-Returnable Items</h2>
              <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-4">
                <div className="flex items-start gap-3">
                  <AlertTriangle className="h-5 w-5 text-amber-600 dark:text-amber-400 mt-0.5 flex-shrink-0" />
                  <p className="text-muted-foreground">
                    Certain products may be non-returnable due to hygiene, customization, or seller-specific restrictions. 
                    Such details will be clearly mentioned on the product page.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">4. Quality Assurance</h2>
              <p className="text-muted-foreground">
                All clothing materials are checked before shipping to ensure quality standards. Minor variations 
                in color or texture may occur due to lighting conditions or screen settings.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">5. Refund Delays or Issues</h2>
              <p className="text-muted-foreground">
                If a refund is not received within the stated timeline, customers are advised to contact 
                AuraKart Support for assistance.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">6. Support Contact</h2>
              <div className="bg-secondary/50 rounded-lg p-6 space-y-4">
                <div className="space-y-3">
                  <div className="flex items-center gap-2 text-foreground">
                    <Phone className="h-4 w-4" />
                    <span className="font-medium">AuraKart Support:</span>
                    <a href="tel:+919345372307" className="text-primary hover:text-primary/80 transition-colors">
                      +91 9345372307
                    </a>
                  </div>
                  <div className="flex items-start gap-2 text-muted-foreground">
                    <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                    <div>
                      <p className="font-medium text-foreground mb-1">Registered Address:</p>
                      <p>1B, Anna Street, Ram Nagar, Ambattur OT,</p>
                      <p>Chennai, Tamil Nadu – 600053</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

          </div>
        </motion.div>
      </div>
    </Layout>
  );
};

export default RefundPolicyPage;